import { dynamicLengthValidator } from '../../../common/Utils/Utils';
import {
  emailValidator,
  internationalPhoneValidator,
} from '../../../common/Validators/Validators';

export const SalesQueryFormField = (
  form,
  Industries,
  selectedIndustry,
  countryCode
) => {
  let fields = [
    {
      label: 'Full Name',
      field: 'name',
      span: 12,
      maxLength: 50,
      type: 'text',
      placeholder: 'Enter your Full name',
      required: true,
      rules: [
        { required: true, message: 'Full Name is required' },
        {
          validator: dynamicLengthValidator(3, 'Full Name'),
        },
      ],
    },
    {
      label: 'Email',
      field: 'emailId',
      span: 12,
      maxLength: 254,
      type: 'text',
      placeholder: 'Enter your email',
      required: true,
      rules: [
        { required: true, message: 'Email is required' },
        {
          validator: dynamicLengthValidator(6, 'Email'),
        },
        emailValidator('Please enter a valid email'),
      ],
    },
    {
      label: 'Company Name',
      field: 'company',
      span: 12,
      type: 'text',
      maxLength: 100,
      placeholder: 'Enter your company name',
      required: true,
      rules: [
        { required: true, message: 'Company Name is required' },
        {
          validator: dynamicLengthValidator(2, 'Company Name'),
        },
      ],
    },
    {
      label: 'Mobile Number',
      field: 'contactDetails',
      span: 12,
      type: 'number',
      maxLength: 15,
      placeholder: 'Enter your mobile number',
      required: true,
      rules: [
        { required: true, message: 'Mobile number is required' },
        {
          validator: internationalPhoneValidator(countryCode),
        },
      ],
    },
    {
      label: 'Industries',
      field: 'industry',
      span: 24,
      showSearch: true,
      placeholder: 'Select Industries',
      required: true,
      allowClear: true,
      labelInValue: true,
      rules: [{ required: true, message: 'Industries is required' }],
      type: 'select',
      options: Industries.map((industry) => ({
        value: industry.id,
        label: industry.name,
      })),
    },
  ];

  if (selectedIndustry === 'Other') {
    fields.push({
      label: 'Specify Industry',
      field: 'otherIndustry',
      type: 'text',
      span: 24,
      required: true,
      placeholder: 'Please specify your industry',
      rules: [
        { required: true, message: 'Please specify your industry' },
        {
          validator: dynamicLengthValidator(2, 'Specify industry'),
        },
      ],
    });
  }
  fields.push({
    label: 'Additional Information',
    field: 'customRequirement',
    type: 'textarea',
    span: 24,
    maxLength: 2000,
    required: true,
    placeholder: 'Tell us about your project or requirements...',
    rules: [
      { required: true, message: 'Additional Information is required' },
      {
        validator: dynamicLengthValidator(3, 'Additional Information'),
      },
    ],
  });

  return fields;
};
